import React from 'react';
import RoleSuccessPage from '../RoleManagement/RoleSuccessPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './PlayerSuccessPage.module.css';

const PlayerSuccessPage: React.FC = () => (
  <RoleSuccessPage config={ROLE_CONFIGS.player} styles={styles} />
);

export default PlayerSuccessPage;
